// A dónde ir justo después de registrarse o entrar por primera vez, según lo que la
// persona estaba haciendo antes de tener sesión.

// Preguntas generadas en la landing sin cuenta: Mis diagnósticos las detecta y abre la
// ventana para crear el diagnóstico.
export const hasPendingQuestions = () => {
  try {
    return Boolean(localStorage.getItem('selectedQuestions') && localStorage.getItem('surveyTopic'));
  } catch (error) {
    return false;
  }
};

// Plan elegido en Precios antes de registrarse: se abre la página de suscripción con él marcado
const takeSelectedPlan = () => {
  try {
    const plan = localStorage.getItem('selectedSubscription');
    if (plan) localStorage.removeItem('selectedSubscription');
    return plan;
  } catch (error) {
    return null;
  }
};

export const subscribePath = (plan) => (plan ? `/subscribe?plan=${encodeURIComponent(plan)}` : '/subscribe');

export const afterAuthPath = (fallback) => {
  if (hasPendingQuestions()) return '/dashboard';
  const plan = takeSelectedPlan();
  return plan ? subscribePath(plan) : fallback;
};
